// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#easycommerce-filter img {
    border: 1px solid#DBDBDB;
    padding: 9px;
    border-radius: 8px;
    box-shadow: 0px 4px 12px 0px #0000001a;
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
    background: #ffffff0f;
    left: 20px;
}
.easycommerce-thumbnail-img {
    width: 100%;
    max-height: 320px;
    -o-object-fit: cover;
       object-fit: cover;
}
.easycommerce-add-to-cart-shop:hover {
    color: #fff !important;
}

.easycommerce-drawer-container {
    width: 300px;
}
.easycommerce-shop-container {
    width: calc(100% - 300px);
}
.easycommerce-price-range-input-field,
.easycommerce-price-range-input-field:focus {
    border: 1px solid var(--color-ec-border) !important;
}
.easycommerce-price-range-input-field::-webkit-outer-spin-button,
.easycommerce-price-range-input-field::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
/* Firefox */
.easycommerce-price-range-input-field[type="number"] {
    -moz-appearance: textfield;
}

@media (max-width: 991px) {
    .easycommerce-shop-container {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./blocks/shops-page/shop/components/assets/style.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;IAClB,sCAAsC;IACtC,kCAA0B;YAA1B,0BAA0B;IAC1B,qBAAqB;IACrB,UAAU;AACd;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,oBAAiB;OAAjB,iBAAiB;AACrB;AACA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;AACA;IACI,yBAAyB;AAC7B;AACA;;IAEI,mDAAmD;AACvD;AACA;;IAEI,wBAAwB;IACxB,SAAS;AACb;AACA,YAAY;AACZ;IACI,0BAA0B;AAC9B;;AAEA;IACI;QACI,WAAW;IACf;AACJ","sourcesContent":["#easycommerce-filter img {\n    border: 1px solid#DBDBDB;\n    padding: 9px;\n    border-radius: 8px;\n    box-shadow: 0px 4px 12px 0px #0000001a;\n    backdrop-filter: blur(5px);\n    background: #ffffff0f;\n    left: 20px;\n}\n.easycommerce-thumbnail-img {\n    width: 100%;\n    max-height: 320px;\n    object-fit: cover;\n}\n.easycommerce-add-to-cart-shop:hover {\n    color: #fff !important;\n}\n\n.easycommerce-drawer-container {\n    width: 300px;\n}\n.easycommerce-shop-container {\n    width: calc(100% - 300px);\n}\n.easycommerce-price-range-input-field,\n.easycommerce-price-range-input-field:focus {\n    border: 1px solid var(--color-ec-border) !important;\n}\n.easycommerce-price-range-input-field::-webkit-outer-spin-button,\n.easycommerce-price-range-input-field::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n/* Firefox */\n.easycommerce-price-range-input-field[type=\"number\"] {\n    -moz-appearance: textfield;\n}\n\n@media (max-width: 991px) {\n    .easycommerce-shop-container {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
